import {useContext, useEffect, useState} from "react";
import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/CustomerUsers.css";
import NewCustomerUser from "./NewCustomerUser.jsx";
import { LoadShortDate } from "../../../../../functions/LoadShortDate.js";
import { LoadShortTime } from "../../../../../functions/LoadShortTime.js";
import { thingsBoardMicroserviceUrl } from "../../../../../microservices/thingsboard_microservice.js";
import { usersMicroserviceUrl } from "../../../../../microservices/users_microservice.js";
import CustomerUser from "./CustomerUser.jsx";
import NewCustomerUserType from "./NewCustomerUserType.jsx";
import AddExistingCustomerUser from "./AddExistingCustomerUser.jsx";
import UnassignCustomerUser from "./UnassignCustomerUser.jsx";
import { useParams } from "react-router-dom";
import NavigationBar from "../../../../navigation_components/NavigationBar.jsx";
import TenantAdministratorSideBar from "../../../../sidebar_components/TenantAdministratorSideBar.jsx";
import { AppContext } from "../../../../AppProvider.jsx";
import { CustomerContext } from "../CustomerProvider.jsx";
import DeleteCustomerUser from "./DeleteCustomerUser.jsx";
const CustomerUsersTable = ({customer,customerUsers,access_token}) =>{
    const{selectedCustomerUser,setSelectedCustomerUser} = useContext(CustomerContext);
    if(!customerUsers || !Array.isArray(customerUsers) || customerUsers.length === 0) return;
    customerUsers = customerUsers.sort((a,b) => {
        if(a.iotRole === 'ADMIN' && b.iotRole !== 'ADMIN') return -1;
        else if(a.iotRole !== 'ADMIN' && b.iotRole === 'ADMIN') return 1;
        return 0;
    });
    return(
        <div className="customer-users-table-container">
            <table className="customer-users-table">
                <thead>
                    <tr id="customer-users-table-header-row">
                        <th>Date registered</th>
                        <th>Time registered</th>
                        <th>First name</th>
                        <th>Last name</th>
                        <th>Email address</th>
                        <th>Role</th>
                    </tr>
                </thead>
                <tbody>
                    {customerUsers && customerUsers.map(customerUser => {
                        return (
                            <tr onClick={async () => {
                                setSelectedCustomerUser(customerUser);
                            }} key={customerUser?.emailAddress}
                            >
                                <td>{LoadShortDate(customerUser?.dateRegistered)}</td>
                                <td>{LoadShortTime(customerUser?.dateRegistered)}</td>
                                <td>{customerUser?.firstName}</td>
                                <td>{customerUser?.lastName}</td>
                                <td>{customerUser?.emailAddress}</td>
                                <td>{customerUser?.iotRole && customerUser?.iotRole === 'ADMIN'? 'Administrator':'User'}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <CustomerUser
                customerUser={selectedCustomerUser}
                setCustomerUser={setSelectedCustomerUser}
                customerId={customer?.local?.id || ''}
                access_token={access_token}
            />
        </div>
    );
}
const CustomerUsers = () =>{
    const {user,logout} = useContext(AppContext);
    const {selectedTenantAdminProfile,reloadCustomerUsers,setReloadCustomerUsers,selectedToDeleteCustomerUser} = useContext(CustomerContext);
    const [customer,setCustomer] = useState(null);
    const [showNewCustomerUserWindow,setShowNewCustomerUserWindow] = useState(false);
    const [showNewCustomerUserTypeWindow,setShowNewCustomerUserTypeWindow] = useState(false);
    const [showAddExistingCustomerUserWindow,setShowAddExistingCustomerUserWindow] = useState(false);
    const [iotCustomerUsersFetched,setIotCustomerUsersFetched] = useState(false);
    const [customerUsersFetched,setCustomerUsersFetched] = useState(false);
    const [iotCustomerUsers,setIotCustomerUsers] = useState([]);
    const [customerUsers,setCustomerUsers] = useState();
    const {customerId} = useParams();
    const fetchCustomer = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/customers/${customerId}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok) setCustomer(await response.json());
            else if(response.status === 401) logout();
            else throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error(`An error occurred when fetching a customer with id ${customerId}`,error);
        }
    };
    const fetchIOTCustomerUsers = async() =>{
        if(customerUsersFetched || iotCustomerUsersFetched) return;
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/customers/${customerId}/assignments`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok) setIotCustomerUsers(await response.json());
            else if(response.status === 401) logout();
            else throw new Error(`status code ${response.status}`);
        }
        catch(error){
            console.error(error);
        }
        setIotCustomerUsersFetched(true);
    };
    async function fetchAndMergeCustomerUsers() {
        const promises = iotCustomerUsers
        .filter(iotCustomerUser => iotCustomerUser?.username)
        .map(async (iotCustomerUser) => {
            try {
                const url = `${usersMicroserviceUrl}/tenants/customer-users/${iotCustomerUser?.username}`;
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${user?.access_token}`,
                        'Content-Type': 'application/json'
                    }
                });
                if(response.ok){
                    const responseData = await response.json();
                    return {
                        id:responseData.id,
                        firstName: responseData.firstName || '',
                        lastName: responseData.lastName || '',
                        emailAddress: responseData.emailAddress || '',
                        phoneNumber:responseData.phoneNumber || '',
                        country: responseData.country || '',
                        city: responseData.city || '',
                        postalCode: responseData.postalCode || '',
                        address: responseData.address || '',
                        address2: responseData.address2 || '',
                        status: responseData.status || '',
                        iotProfileId: iotCustomerUser?.customerUserId || '',
                        iotRole: iotCustomerUser?.role || 'USER',
                        dateRegistered: iotCustomerUser.dateCreated? iotCustomerUser.dateCreated:''
                    };
                }
                else if(response.status === 401) logout();
            } catch (error) {
                console.error(error);
                return null;
            }
        });
        const results = await Promise.all(promises);
        setCustomerUsers(results.filter(user => user !== null));
        setCustomerUsersFetched(true);
    };
    useEffect(() =>{
        fetchCustomer();
        setCustomerUsersFetched(false);
    },[]);
    useEffect(() =>{
        fetchIOTCustomerUsers();
    },[customerUsersFetched]);
    useEffect(() =>{
        if(reloadCustomerUsers){
            setIotCustomerUsersFetched(false);
            setCustomerUsersFetched(false);
            setReloadCustomerUsers(false);
        }
    },[reloadCustomerUsers]);
    useEffect(() =>{
        if(customerUsersFetched || !iotCustomerUsersFetched) return;
        fetchAndMergeCustomerUsers();
    },[iotCustomerUsers,iotCustomerUsersFetched]);
    useEffect(() =>{
        if(!showAddExistingCustomerUserWindow) setCustomerUsersFetched(false);
    },[showAddExistingCustomerUserWindow]);
    return(
        <div className="customer-users-parent-page">
            <div className="customer-users-page">
                <NavigationBar/>
                <div className="customer-users-page-layout">
                    <div>
                        <TenantAdministratorSideBar/>
                    </div>
                    <div className="customer-users-parent-container">
                        <div className="customer-users-container">
                            <div className="customer-users-header-container">
                                <h2>{`${customer?.external?.title || ''}: Customer users`}</h2>
                                <div className="customer-users-header-controls">
                                    <button className="add-new-customer-user-button" onClick={() => {setShowNewCustomerUserTypeWindow(true)}}>
                                        <img src={`${process.env.PUBLIC_URL}/images/add-icon.png`} alt="Add" />
                                    </button>
                                    <button className="refresh-customer-users-button" onClick={() =>{}}>
                                        <img src={`${process.env.PUBLIC_URL}/images/refresh-icon.png`} alt="Refresh"/>
                                    </button>
                                </div>
                            </div>
                            {
                                customerUsers?.length > 0?
                                (
                                    <CustomerUsersTable
                                        customer={customer}
                                        customerUsers={customerUsers}
                                        access_token={user?.access_token}
                                    />
                                ):!showNewCustomerUserTypeWindow && !showNewCustomerUserWindow && !showAddExistingCustomerUserWindow && !selectedToDeleteCustomerUser?
                                (
                                    <div className="customer-users-unavailable-container">
                                        <p>No customer users available.</p>
                                    </div>
                                ):
                                (<></>)
                            }
                        </div>
                    </div>
                </div>
            </div>
            <NewCustomerUserType
                showNewCustomerUserTypeWindow = {showNewCustomerUserTypeWindow}
                setShowNewCustomerUserTypeWindow = {setShowNewCustomerUserTypeWindow}
                setShowNewCustomerUserWindow = {setShowNewCustomerUserWindow}
                setShowAddExistingCustomerUserWindow={setShowAddExistingCustomerUserWindow}
            />
            <NewCustomerUser
                showNewCustomerUserWindow={showNewCustomerUserWindow}
                setShowNewCustomerUserWindow={setShowNewCustomerUserWindow}
                customer={customer}
            />
            <AddExistingCustomerUser
                showAddExistingCustomerUserWindow={showAddExistingCustomerUserWindow}
                setShowAddExistingCustomerUserWindow={setShowAddExistingCustomerUserWindow}
                customer={customer}
            />
            <UnassignCustomerUser/>
            <DeleteCustomerUser/>
        </div>
    );
};
export default CustomerUsers;